export const shopPrefix = '/api/shop';
export const localContentPrefix = '/api/lc';

const HEADER_MOCKSERVER = 'x-response-type';
const HEADER_MOCKSERVER_TYPE = 'selenium-mock-server';
const HEADER_BORROWBOX = 'x-borrowbox';
const HEADER_BORROWBOX_REQUESTID = `${HEADER_BORROWBOX}-requestid`;
const HEADER_BORROWBOX_SPOC = `${HEADER_BORROWBOX}-spoc`;
const HEADER_BORROWBOX_LANGUAGE = `${HEADER_BORROWBOX}-language`;

export const GlobalReactQueryOptions = {
    refetchOnWindowFocus: false
};

export const HeaderRequestFields = {
    HEADER_MOCKSERVER,
    HEADER_MOCKSERVER_TYPE,
    HEADER_BORROWBOX_REQUESTID,
    HEADER_BORROWBOX_SPOC,
    HEADER_BORROWBOX_LANGUAGE
};

export function appConfig() {
    return {
        endpointHealth: '/manage/health',
        endpointTutorial: `${shopPrefix}/v2/tutorial`
    };
}

export function cartConfig() {
    return {
        endpoint: `${shopPrefix}/v1/shoppingcart`,
        endpointPreview: `${shopPrefix}/v1/shoppingcart/summary`,
        endpointUnvailableProducts: `${shopPrefix}/v1/shoppingcart/unavailableproducts`,
        endpointProducts: `${shopPrefix}/v1/shoppingcart/products/:productId?/:copyId?`,
        endpointMeta: `${shopPrefix}/v1/shoppingcart/meta`,
        endpointConfirmOrder: `${shopPrefix}/v1/shoppingcart/order`,
        endpointAccounts: `${shopPrefix}/v1/accounts`,
        endpointGroup: `${shopPrefix}/v1/shoppingcart/:group/:id?`,
        endpointCSVDownload: `${shopPrefix}/v1/shoppingcart/download`,
        bulkUpdateUsageConditions: `${shopPrefix}/v1/shoppingcart/bulk/usage-conditions`,
        subscriptionPeriods: `${shopPrefix}/v1/shoppingcart/subscriptionperiods`
    };
}

export function selectionlistConfig() {
    return {
        endpoint: `${shopPrefix}/v1/selectionlists/:listId?`,
        endpointUnvailableProducts: `${shopPrefix}/v1/selectionlists/:listId/unavailableproducts`,
        endpointProducts: `${shopPrefix}/v1/selectionlists/:listId/products/:productId?/:copyId?`,
        endpointGroup: `${shopPrefix}/v1/selectionlists/:listId/:group/:id?`,
        endpointApproval: `${shopPrefix}/v1/selectionlists/:listId/approverequest`,
        endpointCSVDownload: `${shopPrefix}/v1/selectionlists/:listId/download`,
        endpointPdfDownload: `${shopPrefix}/v1/selectionlists/:listId/pdf`,
        endpointRequiredSpoc: `${shopPrefix}/v1/selectionlists/:listId/requiredspoc`,
        bulkUpdateUsageConditions: `${shopPrefix}/v1/selectionlists/:listId/bulk/usage-conditions`
    };
}

export function localContentConfig() {
    return {
        endpointPerformers: `${localContentPrefix}/v1/localcontent/performers/:performerId?`,
        endpointPerformersMeta: `${localContentPrefix}'/v1/localcontent/performers/:performerId/meta`,
        endpointProduct: `${localContentPrefix}/v1/localcontent/products/:id?`,
        endpointGenres: `${localContentPrefix}/v1/localcontent/genres`,
        endpointGenreCategories: `${localContentPrefix}/v1/localcontent/genres/categories`,
        endpointCredit: `${localContentPrefix}/v1/localcontent/credit`,
        endpointCreditSummary: `${localContentPrefix}/v1/localcontent/credit/summary`,
        endpointLocalGenres: `${localContentPrefix}/v1/localcontent/genres/local`,
        endpointStandardGenres: `${localContentPrefix}/v1/localcontent/genres/standard`,
        endpointCountries: `${localContentPrefix}/v1/localcontent/countries`,
        endpointLanguages: `${localContentPrefix}/v1/localcontent/languages`,
        endpointAssets: `${localContentPrefix}/v1/localcontent/products/asset/:id`,
        endpointCovers: `${localContentPrefix}/v1/localcontent/products/cover/:id`,
        endpointDeleteCover: `${localContentPrefix}/v1/localcontent/products/cover/:id`,
        endpointPublishProduct: `${localContentPrefix}/v1/localcontent/products/:id/publish`,
        endpointRepublishProduct: `${localContentPrefix}/v1/localcontent/products/:productId/republish`,
        endpointDeactivateProduct: `${localContentPrefix}/v1/localcontent/products/:productId/deactivate`,
        endpointWithdrawProduct: `${localContentPrefix}/v1/localcontent/products/:productId/libxchange/withdraw`,
        endpointSetLiveLibXchange: `${localContentPrefix}/v1/localcontent/products/:productId/libxchange/setlive`,
        endpointReactivateProduct: `${localContentPrefix}/v1/localcontent/products/:productId/reactivate`,
        endpointProductLibxOptions: `${localContentPrefix}/v1/localcontent/products/:productId/libxchange/settings`,
        endpointCancelPublishing: `${localContentPrefix}/v1/localcontent/products/:id/cancel`,
        endpointRequiredSpoc: `${localContentPrefix}/v1/localcontent/products/:id/requiredspoc`,
        endpointKeywordSuggestions: `${localContentPrefix}/v1/localcontent/keywords`
    };
}

export function productConfig() {
    return {
        endpointProduct: `${shopPrefix}/v1/products/:productId`,
        endpointBackIssues: `${shopPrefix}/v1/products/:productId/backissues`
    };
}

export function bundleConfig() {
    return {
        endpointBundles: `${shopPrefix}/v1/bundles/:loanFormat/:kind?`,
        endpointForeignLanguageBundles: `${shopPrefix}/v1/foreignlanguage/bundles/:loanFormat?/:kind?`,
        endpointBundle: `${shopPrefix}/v1/bundles/:bundleId/details`,
        endpointBundleTotals: `${shopPrefix}/v1/bundles/:bundleId/totals`,
        endpointRelatedBundles: `${shopPrefix}/v1/bundles/related/:productId`
    };
}

export function productlistConfig() {
    return {
        endpointByProductType: `${shopPrefix}/v2/standard/allproducts/:loanFormat/:productType/:kind`,
        endpointLote: `${shopPrefix}/v1/lote/allproducts/:kind`,
        endpointLanguageLearning: `${shopPrefix}/v1/languagelearning/allproducts/:kind`,
        endpointSelectionlists: `${shopPrefix}/v1/selectionlists/:id/:kind`,
        endpointShoppingcart: `${shopPrefix}/v1/shoppingcart/:kind`,
        endpointBundles: `${shopPrefix}/v1/bundles/:bundleId/:kind`,
        endpointSearchSuggestionsLoanFormat: `${shopPrefix}/v2/catalogue/suggestions/:loanFormat?`,
        endpointSearchSuggestions: `${shopPrefix}/v2/catalogue/suggestions`,
        endpointCollection: `${shopPrefix}/v2/collection/complete/:kind?`,
        endpointNewlyAdded: `${shopPrefix}/v2/collection/newly_added/:kind`,
        endpointByGenre: `${shopPrefix}/v2/collection/by-genre/:genre/:kind`,
        endpointLocalContent: `${localContentPrefix}/v1/localcontent/list/:kind`,
        endpointLocalContentCollection: `${localContentPrefix}/v1/localcollectioncontent/list/:kind`,
        endpointLibxAllTitles: `${localContentPrefix}/v1/marketplace/list/:kind`,
        endpointLibxNewlyAdded: `${localContentPrefix}/v1/marketplace/newlyadded/:kind`,
        endpointLibxGenres: `${localContentPrefix}/v1/marketplace/genres/:genre/:kind`,
        endpointLibxLocalRegions: `${localContentPrefix}/v1/marketplace/localregions/:region/:kind`,
        endpointLoteNewlyAdded: `${shopPrefix}/v2/lote/newly_added/:kind`,
        endpointLanguageLearningNewlyAdded: `${shopPrefix}/v2/languagelearning/newly_added/:kind`,
        endpointForeignLanguagesGenres: `${shopPrefix}/v2/lote/genre/:genre/:kind`,
        endpointCampaign: `${shopPrefix}/v1/campaignproducts/allproducts/:kind`,
        endpointMarketingCampaign: `${shopPrefix}/v1/marketing/campaigns/:kind?`,
        endpointLibraryManaged: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/:kind`
    };
}

export function collectionConfig() {
    return {
        endpointGenres: `${shopPrefix}/v2/collection/by-genre`,
        endpointByGenreProducts: `${shopPrefix}/v2/collection/by-genre/:genre/products`
    };
}

export function filterQuicksearchConfig() {
    return {
        endpointByProductType: `${shopPrefix}/v2/standard/allproducts/:loanFormat/:productType/:kind/quicksearch`,
        endpointLote: `${shopPrefix}/v1/lote/allproducts/aggregation/quicksearch`,
        endpointLanguageLearning: `${shopPrefix}/v1/languagelearning/allproducts/aggregation/quicksearch`,
        endpointSelectionlists: `${shopPrefix}/v1/selectionlists/:id/aggregation/quicksearch`,
        endpointShoppingcart: `${shopPrefix}/v1/shoppingcart/aggregation/quicksearch`,
        endpointBundles: `${shopPrefix}/v1/bundles/:bundleId/aggregation/quicksearch`,
        endpointCollection: `${shopPrefix}/v2/collection/complete/aggregation/quicksearch`,
        endpointNewlyAdded: `${shopPrefix}/v2/collection/newly_added/aggregation/quicksearch`,
        endpointReserveListItems: `${shopPrefix}/v1/reservelist/:reserveListId/aggregation/quicksearch`,
        endpointLocalContent: `${localContentPrefix}/v1/localcontent/list/aggregation/quicksearch`,
        endpointLocalContentCollection: `${localContentPrefix}/v1/localcollectioncontent/list/aggregation/quicksearch`,
        endpointByGenre: `${shopPrefix}/v2/collection/by-genre/:genre/aggregation/quicksearch`,
        endpointLibxAllTitles: `${localContentPrefix}/v1/marketplace/list/aggregation/quicksearch`,
        endpointLibxNewlyAdded: `${localContentPrefix}/v1/marketplace/newlyadded/aggregation/quicksearch`,
        endpointLibxGenres: `${localContentPrefix}/v1/marketplace/genres/:genre/aggregation/quicksearch`,
        endpointLibxLocalRegions: `${localContentPrefix}/v1/marketplace/list/aggregation/quicksearch`, //TODO replace by local-region endpoint(when implemented)
        endpointLoteNewlyAdded: `${shopPrefix}/v2/lote/newly_added/aggregation/quicksearch`,
        endpointLanguageLearningNewlyAdded: `${shopPrefix}/v2/languagelearning/newly_added/aggregation/quicksearch`,
        endpointForeignLanguagesGenres: `${shopPrefix}/v2/lote/genre/:genre/aggregation/quicksearch`,
        endpointCampaign: `${shopPrefix}/v1/campaignproducts/allproducts/aggregation/quicksearch`,
        endpointMarketingCampaign: `${shopPrefix}/v1/marketing/campaigns/aggregation/quicksearch`,
        endpointLibraryManaged: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/aggregation/quicksearch`,
        endpointSearch: `${shopPrefix}/v1/catalogue/search/aggregation/quicksearch/:scope`,
        endpointCollectionSearch: `${shopPrefix}/v2/collection/complete/search/aggregation/quicksearch/:scope`
    };
}

export function campaignConfig() {
    return {
        endpointPromotion: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/promotion`,
        endpointDiagramCumulativeLoans: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/cumulativeloans`,
        endpointDiagramCumulativeUser: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/cumulativeusers`,
        endpointDiagramTotalLoans: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/totalloans`,
        endpointDiagramTotalLoansSharedOnly: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/totalloans/shared`,
        endpointVisits: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/visits`,
        endpointMarketingSettings: `${shopPrefix}/v1/marketing/campaigns/products/:campaignProductId/period`,
        endpointPdfDownload: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/pdf`,
        endpointMarketingMaterial: `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/materialurl`
    };
}

export function libraryManagedConfig() {
    return {
        endpointProductGroupProducts: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/products`,
        endpointProductGroupBulk: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/:kind/:action`,
        endpointProductGroupBulkSource: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/:source/:kind/:action`,
        endpointProductGroupProductsSorting: `${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/products/sort`,
        endpointProductGroupsReorder: `${shopPrefix}/v1/librarymanaged/featured-page-product-group-slots/reorder`,
        endpointProductGroupSortAndTitle: `${shopPrefix}/v1/librarymanaged/featured-page-product-groups/:productGroupId`,
        endpointUpdateProductGroupSlot: `${shopPrefix}/v1/librarymanaged/featured-page-product-group-slots/:slotId`
    };
}

export function reservesConfig() {
    return {
        endpointReserveListGenerate: `${shopPrefix}/v1/reservelist/generate`,
        endpointReserveListDefaultSetting: `${shopPrefix}/v1/reservelist/defaultsetting`,
        endpointReserveListOverview: `${shopPrefix}/v1/reservelist`,
        endpointReserveFinancialYears: `${shopPrefix}/v1/reservelist/financialyears`,
        endpointReserveSummary: `${shopPrefix}/v1/reservelist/:reserveListId`,
        endpointReserveProduct: `${shopPrefix}/v1/reservelist/:reserveListId/products/:productId`,
        endpointReserveProductAcceptReject: `${shopPrefix}/v1/reservelist/:reserveListId/products/:productId`,
        endpointReserveProductCopyAmountChange: `${shopPrefix}/v1/reservelist/:reserveListId/products/:productId`,
        endpointReserveBulkAcceptReject: `${shopPrefix}/v1/reservelist/:reserveListId/bulk/:action`,
        endpointReserveProductCopies: `${shopPrefix}/v1/reservelist/:reserveListId/products/:productId`,
        endpointReserveProductCopiesDelete: `${shopPrefix}/v1/reservelist/:reserveListId/products/:productId/:copyId`,
        endpointReserveCheckout: `${shopPrefix}/v1/reservelist/:reserveListId/checkout`,
        endpointReserveCheckoutProducts: `${shopPrefix}/v1/reservelist/:reserveListId/checkout/products`,
        endpointReserveCheckoutMeta: `${shopPrefix}/v1/reservelist/:reserveListId/checkout/meta`,
        endpointReserveCheckoutSummary: `${shopPrefix}/v1/reservelist/:reserveListId/checkout/summary`,
        endpointReserveCheckoutOrder: `${shopPrefix}/v1/reservelist/:reserveListId/checkout`,
        endpointReserveCheckoutUnavailable: `${shopPrefix}/v1/reservelist/:reserveListId/checkout/unavailableproducts`,
        endpointReserveListReopen: `${shopPrefix}/v1/reservelist/reopen/:reserveListId`,
        endpointReserveRequiredSpoc: `${shopPrefix}/v1/reservelist/:reserveListId/requiredspoc`
    };
}
